import styled from 'styled-components';
import { Route } from 'react-router-dom';
import { useManageGeneratableDocumentsController } from '@dealstack/frontend/admin/pages/Manage/ManageGeneratableDocuments/useManageGeneratableDocumentsController.ts';
import { GeneratableDocumentsTable } from './GeneratableDocumentsTable/GeneratableDocumentsTable.tsx';
import { EditGeneratableDocument } from './EditGeneratableDocument/EditGeneratableDocument.tsx';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.tsx';
import { GODMODE_ROOT_ROUTES } from '@dealstack/frontend/admin/pages/Routing/Routing.tsx';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry.ts';

interface Props {
	className?: string;
}
export enum MANAGE_GENERATABLE_DOCUMENTS_ROUTES {
	EDIT = 'edit/:templateId',
}

const ManageGeneratableDocuments = ({ className }: Props) => {
	const { documentsTemplates } = useManageGeneratableDocumentsController();

	useBreadcrumbs([
		{ name: 'Generatable documents', url: GODMODE_ROOT_ROUTES.MANAGE_GENERATABLE_DOCUMENTS },
	]);

	return (
		<div className={className}>
			<SentryRoutes>
				<Route
					path={MANAGE_GENERATABLE_DOCUMENTS_ROUTES.EDIT}
					element={
						<EditGeneratableDocument
							documentsTemplates={documentsTemplates}
							key={documentsTemplates?.length}
						/>
					}
				/>

				<Route
					path="*"
					element={<GeneratableDocumentsTable documentsTemplates={documentsTemplates} />}
				/>
			</SentryRoutes>
		</div>
	);
};

const Styled = styled(ManageGeneratableDocuments)`
	padding: 2rem;
	color: ${(props) => props.theme.v3.colors.dark[8]};
`;

export { Styled as ManageGeneratableDocuments };
